"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var ArrowCircleDownRight = function (_a) {
    var size = _a.size, title = _a.title, color = _a.color, svgProps = __rest(_a, ["size", "title", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', viewBox: "0 0 24 24", style: __assign({ color: color }, svgProps.style), xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "arrow-circle-down-right" },
            react_1.default.createElement("path", { id: "Icon", d: "M16.0002 9.00005C16.0002 8.44777 15.5525 8.00005 15.0002 8.00005C14.4479 8.00005 14.0002 8.44777 14.0002 9.00005H16.0002ZM15.0002 15.0001V16.0001C15.5525 16.0001 16.0002 15.5523 16.0002 15.0001H15.0002ZM9.00019 14.0001C8.4479 14.0001 8.00019 14.4478 8.00019 15.0001C8.00019 15.5523 8.4479 16.0001 9.00019 16.0001V14.0001ZM9.7073 8.29284C9.31678 7.90231 8.68361 7.90231 8.29309 8.29283C7.90256 8.68335 7.90255 9.31651 8.29307 9.70704L9.7073 8.29284ZM21 12C21 16.9706 16.9706 21 12 21V23C18.0751 23 23 18.0751 23 12H21ZM12 21C7.02944 21 3 16.9706 3 12H1C1 18.0751 5.92487 23 12 23V21ZM3 12C3 7.02944 7.02944 3 12 3V1C5.92487 1 1 5.92487 1 12H3ZM12 3C16.9706 3 21 7.02944 21 12H23C23 5.92487 18.0751 1 12 1V3ZM14.0002 9.00005V15.0001H16.0002V9.00005H14.0002ZM15.0002 14.0001H9.00019V16.0001H15.0002V14.0001ZM8.29307 9.70704L14.2931 15.7072L15.7073 14.293L9.7073 8.29284L8.29307 9.70704Z" }))));
};
exports.default = ArrowCircleDownRight;
